import { render } from "./MetricAssertionDetailPage.vue?vue&type=template&id=e1f6de2a&scoped=true"
import script from "./MetricAssertionDetailPage.vue?vue&type=script&lang=js"
export * from "./MetricAssertionDetailPage.vue?vue&type=script&lang=js"

import "./MetricAssertionDetailPage.vue?vue&type=style&index=0&id=e1f6de2a&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f6de2a"]])

export default __exports__